import Box from '@mui/material/Box'
import Image from 'next/image'
import { FC } from 'react'

import TitleAndParagraph from '@/components/TitleAndParagraph'
import TwoColumnLayout, { ColumnWrapOrder } from '@/components/TwoColumnLayout'

const PlugInAndGoAPI: FC = () => {
    return (
        <Box>
            <TwoColumnLayout
                leftCol={6}
                rightCol={5}
                columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}
            >
                <TitleAndParagraph
                    sx={{ maxWidth: '588px' }}
                    title={`Plug in and go with a seamless API integration`}
                    paragraph={
                        'Lune customers integrate our API within hours with support from our engineers.'
                    }
                />
                <Box sx={{ display: 'flex' }}>
                    <Box
                        sx={{
                            width: '100%',
                            height: '0',
                            paddingBottom: '100%',
                            position: 'relative',
                            img: {
                                position: 'absolute',
                                left: 0,
                                right: 0,
                                top: 0,
                                bottom: 0,
                                width: '100%',
                                height: '100%',
                            },
                        }}
                    >
                        <Image
                            width={486}
                            height={486}
                            src={'/illustrations/plug-in-and-go/api-filled.png'}
                            alt={'Plug in and go API'}
                        />
                    </Box>
                </Box>
            </TwoColumnLayout>
        </Box>
    )
}

export default PlugInAndGoAPI
